import { JDSActionButtonProps } from './generated';
import { formatIconName } from '../jdsicon/logic';
import { forwardRef } from 'react';

export interface ActionButtonProps
  extends Omit<JDSActionButtonProps, 'onClick' | 'onFocus'> {
  kind?: 'primary' | 'secondary' | 'tertiary';
  size?: 'medium' | 'small' | 'large' | 'extra-large';
  appearance?: 'normal' | 'positive' | 'negative' | 'contrast';
  state?: 'normal' | 'disabled' | 'loading';
  iconPosition?: 'left' | 'right';
  stretch?: boolean;
  label?: string;
  icon?: string | JSX.Element;
  onClick?: (ev: React.MouseEvent<HTMLDivElement>) => void;
  onFocus?: (ev: React.FocusEvent<HTMLDivElement>) => void;
  onBlur?: (ev: React.FocusEvent<HTMLDivElement>) => void;
  ariaDescribedby?: string;
  ariaLabel?: string;
}

export const withLogic = (
  Component: React.ComponentType<JDSActionButtonProps>
): React.FC<JDSActionButtonProps> =>
  forwardRef<HTMLButtonElement, JDSActionButtonProps>(
    (props: JDSActionButtonProps, ref) => {
      return (
        <Component
          {...{
            ...props,
            _hasLabel: Boolean(props.label?.length),
            rootRef: ref,
            iconAriaLabel:
              props.iconAriaLabel || formatIconName(props.icon as string)
          }}
        />
      );
    }
  );
